import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Optional } from '@angular/core';
import { IMultisiteItem, MultisiteService } from '@df/core/service/multisite';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MultisiteFlagComponent } from './multisite-flag.component';

@Component({
    selector: 'multisite-label',
    templateUrl: 'multisite-label.component.html',
    standalone: true,
    imports: [CommonModule, IfSizeDirective, MultisiteFlagComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultisiteLabelComponent implements OnInit {
    constructor(
        private multisiteService: MultisiteService,
        @Optional() protected modalRef: ModalRef<MultisiteLabelComponent>
    ) {}

    site!: IMultisiteItem;

    ngOnInit() {
        this.site = this.multisiteService.current;
    }

    close(): void {
        this.modalRef?.close();
    }
}
